import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RecordDetail, RecordDetailRow, RecordDetailSection } from './record-detail.model';

/**
 * Renders a RecordDetail as the body of a side sheet. It is a pure renderer: the scrim, the
 * slide-in, Escape handling and focus restoration all belong to the sheet shell now, which is why
 * none of the panel's former focus/keyboard code survives here.
 */
@Component({
  selector: 'csi-record-detail-sheet',
  templateUrl: './record-detail-sheet.component.html',
  styleUrls: ['./record-detail-sheet.component.scss']
})
export class RecordDetailSheetComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public detail: RecordDetail,
    private sheetReference: MatDialogRef<RecordDetailSheetComponent, void>
  ) {}

  public close(): void {
    this.sheetReference.close();
  }

  public trackBySectionTitle(index: number, section: RecordDetailSection): string {
    return section.title;
  }

  public trackByRowLabel(index: number, row: RecordDetailRow): string {
    return row.label;
  }
}
